import React, { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import FlooringAgent from "./components/FlooringSlot";
import companyLogo from "../../images/freshworks-icon.png";
import MoreIcon from "../../images/more-horizontal.png";
import { LuCalendar } from "react-icons/lu";
import { HiArrowLeft } from "react-icons/hi";
import axios from "../../helpers/axios";
import dayjs from "dayjs";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

import {
  Menu,
  MenuItem,
  ThemeProvider,
  alpha,
  createTheme,
  styled,
} from "@mui/material";
import { BorderColorOutlined, DeleteOutline } from "@mui/icons-material";
import { useToast } from "@chakra-ui/react";
import SlotItem from "./components/SlotItem";
import { useLocation } from "react-router-dom";
export default function FlooringPremium() {
  const location = useLocation();
  const pagePermission = location.state;
  //console.log("PREMIUMpagePermission", pagePermission);
  const toast = useToast();
  const [anchorEl, setAnchorEl] = useState(null);
  const [delPopOpen, setDelPopOpen] = useState(false);
  const [editPopOpen, setEditPopOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [premiumData, setPremiumData] = useState([]);
  const [rawPremiumData, setRawPremiumData] = useState([]);
  const [slot, setSlot] = useState("");
  const manageAgentSlotRef = useRef(null);

  const open = Boolean(anchorEl);
  useEffect(() => {
    reloadPremiumData();
  }, []);

  const reloadPremiumData = async () => {
    try {
      const { data } = await axios.post(`/admin/flooring/premium/list`);
      if (!Array.isArray(data?.data)) return;
      // Step 1: Determine the number of rows
      const numRows = data.data.length;

      // Step 2: Determine the number of columns based on the maximum length of items
      let numCols = 0;
      data.data.forEach((slotData) => {
        const itemsLength = slotData.items.length;
        //console.log("0", { itemsLength });
        if (itemsLength + 1 > numCols) {
          //console.log({ itemsLength });
          numCols = itemsLength + 1;
        }
      });

      //console.log({ numCols });
      // Step 3: Initialize an empty grid array
      const grid = new Array(numRows)
        .fill(null)
        .map(() => new Array(numCols).fill(null));

      // Step 4: Populate the grid array with slot information and items
      data.data.forEach((slotData, rowIndex) => {
        const items = slotData.items;
        items.forEach((item, colIndex) => {
          grid[rowIndex][colIndex] = item;
        });
        let nullIndex = grid[rowIndex].indexOf(null);
        if (nullIndex !== -1) {
          grid[rowIndex][nullIndex] = "";
        }
      });

      // Print the grid array
      grid.forEach((row) => {
        //console.log(row);
      });

      setRawPremiumData(data.data);
      setPremiumData(grid);
      //console.log({ grid });
    } catch (error) {
      console.error(error);
    }
  };
  const handleClick = (event, item) => {
    //console.log(event);
    setAnchorEl(event.currentTarget);
    setSlot(item?.slot);
    setPopupData(item);
  };
  const handleOpenDel = (item) => {
    //console.log({ popupData });
    handleCloseMenu();
    setDelPopOpen(true);
  };
  const handleCloseDel = () => {
    setPopupData(null);
    setDelPopOpen(false);
  };
  const handleConfirmDel = async () => {
    try {
      //console.log({ popupData });
      if (popupData?.id) {
        const { data } = await axios.delete(
          `/admin/flooring/premium/delete/${popupData.id}`
        );
        setDelPopOpen(false);
        toast({
          description: "Premium slot deleted successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        reloadPremiumData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseMenu = (act) => {
    setAnchorEl(null);
    if (act === "edit") {
      setEditPopOpen(true);
    }
    if (act === "del") {
      setDelPopOpen(true);
    }
  };

  const handleBackdropClick = () => {
    setEditPopOpen(false);
    setPopupData(null);
  };

  return (
    <ThemeProvider theme={createTheme()}>
      <div className="main_content flex flex-col bg-[#F5F5F5] min-[991px]:overflow-hidden w-[100%] max-h-screen">
        <div className="top-0">
          <div className="flex py-[20px] justify-between items-center px-[24px] max-[600px]:flex-col max-[600px]:items-start">
            <div className="font-[700] text-[20px]">Flooring</div>
          </div>
          <div className="flex flex-row gap-2 mt-3 max-[500px]:hidden block">
            <p className="ml-6 font-medium text-[14px] text-[#53646E] w-[310px]">
              Current Premium
            </p>
            <p className="font-medium text-[14px] text-[#53646E]">Upcoming</p>
          </div>
        </div>
        <div className="bg-[#F5F5F5] flex-col px-6 min-[991px]:overflow-y-auto">
          {premiumData.map((row, index) => (
            <div
              key={index}
              className={`flex flex-[1] flex-row gap-2 my-3 overflow-x-scroll scBarHidden`}
            >
              <div className="max-[500px]:block hidden border border-1 rounded-md bg-white sticky left-0 z-10">
                <div className="text-[12px] text-[#0F0F0F] font-medium text-center items-center justify-center h-full w-[65px] flex">
                  <span>{`Slot\n${index + 1}`}</span>
                </div>
              </div>
              {row.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className={`${
                    itemIndex === 0 ? `sm:sticky sm:left-0 sm:z-10` : ``
                  } max-[500px]:flex-row max-[500px]:flex max-[500px]:items-center`}
                >
                  {item ? (
                    <SlotItem
                      item={item}
                      itemIndex={itemIndex}
                      handleCloseMenu={handleCloseMenu}
                      handleOpenDel={handleOpenDel}
                      open={open}
                      type="agent"
                      anchorEl={anchorEl}
                      handleClick={(e) => handleClick(e, item)}
                      pagePermission={pagePermission}
                    />
                  ) : item == "" ? (
                    <div className="flex flex-row items-center w-[257px] min-[500px]:w-[310px] bg-white  border border-1 rounded-md">
                      {rawPremiumData[index] &&
                        Array.isArray(rawPremiumData[index].items) &&
                        rawPremiumData[index]?.items?.length === 0 && (
                          <div className="h-full text-[12px] max-[500px]:hidden p-2 px-2 text-[#0F0F0F] font-medium flex flex-col items-center justify-center p-1 ">
                            <div className=" w-[35px] flex items-center justify-center">
                              <div className="text-center">
                                <span>Slot</span>
                                <br />
                                {index + 1}
                              </div>
                            </div>
                          </div>
                        )}

                      {pagePermission?.create_permission == 1 && (
                        <div
                          onClick={() => {
                            setSlot(index + 1);
                            setPopupData(null);
                            setEditPopOpen(true);
                          }}
                          className="p-2 w-full h-[54px] px-4 bg-white rounded-md flex justify-center items-center text-xs border border-1 border-blue-600 border-dotted text-blue-600 hover:cursor-pointer"
                        >
                          Add new
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          ))}
          {editPopOpen && (
            <FlooringAgent
              closePopUp={(updated) => {
                setEditPopOpen(false);
                setPopupData(null);
                updated && reloadPremiumData();
              }}
              formType="agent"
              editData={popupData}
              slot={slot}
            />
          )}

          <Dialog
            open={delPopOpen}
            onClose={handleCloseDel}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              sx={{ textAlign: "center", fontFamily: '"Inter", sans-serif' }}
              id="responsive-dialog-title"
            >
              {"Are you sure want to delete?"}
            </DialogTitle>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                autoFocus
                sx={{ color: "red" }}
                onClick={handleConfirmDel}
              >
                Delete
              </Button>
              <Button onClick={handleCloseDel} autoFocus>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </ThemeProvider>
  );
}
